import { getHttpClient } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  UpdateContactListObjReq,
} from '@/api/models';

export async function updateContactList(
  req: UpdateContactListObjReq,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Devices/ContactList',
    req,
  );
  return response.data;
}
